import React, { useEffect, useRef } from 'react';
function useReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => el.classList.add('in-view'), delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.08
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return ref;
}
const narraMetrics = [{
  value: '6,000+',
  label: 'Seafarers served'
}, {
  value: '$91K',
  label: 'ARR in 2 years'
}, {
  value: '27',
  label: 'Clients'
}, {
  value: '7',
  label: 'Distribution partners'
}];
const NARRA_VIDEO = 'https://i.imgur.com/EQoAs5U.mp4';
function NarraVideo() {
  return <video src={NARRA_VIDEO} autoPlay loop muted playsInline preload="none" className="block h-full w-full" style={{
    objectFit: 'cover'
  }} data-id="element-94" data-mp="h97tamd347go" />;
}
export function NarraCaseStudy() {
  const headerRef = useReveal();
  const caseRef = useReveal(80);
  return <section id="narra" className="w-full pt-20 md:pt-32 pb-12 md:pb-16 dark-section" style={{
    background: 'var(--bg)'
  }} data-id="element-95" data-mp="2ge9y7ybp4ned">
      <div className="content-wrap px-6 md:px-12" data-id="element-96" data-mp="26n5iuxi3z0j0">
        <div ref={headerRef} className="reveal mb-4 md:mb-8" data-id="element-97" data-mp="26mcjihlhbdaw">
          <p className="font-aspekta text-xs font-medium tracking-widest uppercase mb-4" style={{
          color: 'var(--accent)'
        }} data-id="element-98" data-mp="21nszwnucydlp">
            Featured case study
          </p>
          <h2 className="text-4xl md:text-6xl tracking-tight" style={{
          color: 'var(--fg)'
        }} data-id="element-99" data-mp="1smusdvkpnnyd">
            Narra Health
          </h2>
        </div>

        <div ref={caseRef} className="reveal grid grid-cols-1 items-start gap-8 py-10 md:grid-cols-2 md:gap-20 md:py-16" data-id="element-100" data-mp="1nq4cb88woscy">
          <div className="flex flex-col items-start text-left" data-id="element-101" data-mp="3i1swppxwpn4q">
            <img src="https://cdn.magicpatterns.com/uploads/ocLvdZc71ZNKULum6ZLUwF/Group_4.svg" alt="Narra Health logo" className="mb-6" style={{
            height: 40,
            width: 'auto',
            filter: 'brightness(0) invert(1)'
          }} data-id="element-102" data-mp="3i0hrrmsq69c1" />
            <p className="font-aspekta text-2xl md:text-3xl leading-snug mb-8" style={{
            maxWidth: '36ch',
            color: 'var(--fg)'
          }} data-id="element-103" data-mp="16gsc9lgr3rsq">
              Building scalable mental wellness infrastructure for the ~1.9M
              workforce behind a $2T industry
            </p>

            <div className="mb-8 block w-full overflow-hidden rounded-2xl md:hidden" style={{
            aspectRatio: '1 / 1'
          }} data-id="element-104" data-mp="240mywi7ar9s1">
              <NarraVideo data-id="element-105" data-mp="1u4jlgg6zvops" />
            </div>

            <p className="text-base md:text-lg leading-relaxed mb-10" style={{
            maxWidth: '52ch',
            color: 'var(--muted)'
          }} data-id="element-106" data-mp="1u38j8kt76p0s">
              I led product for Narra from day one, shaping the TeleHealth
              platform behind their vision for seafarer mental wellness. We
              launched a proof-of-concept and client pilot in under three
              months, then built the full platform over the following seven
              months for a January 2026 launch. Today I sit on Narra's Product
              Advisory Board as the team heads into its seed raise.
            </p>

            <dl className="grid w-full grid-cols-2 gap-x-8 gap-y-6 pt-8" style={{
            borderTop: '1px solid var(--border)'
          }} data-id="element-107" data-mp="31u4fecndaxqk">
              {narraMetrics.map(metric => <div key={metric.label} data-id="element-108" data-mp="295qhry06y3fj">
                  <dt className="sr-only" data-id="element-109" data-mp="2mz841qk9hu99">{metric.label}</dt>
                  <dd data-id="element-110" data-mp="2i89iockf25z5">
                    <span className="block font-aspekta text-3xl md:text-4xl tracking-tight" style={{
                  color: 'var(--fg)'
                }} data-id="element-111" data-mp="2i7pyep7an5hy">
                      {metric.value}
                    </span>
                    <span className="font-aspekta mt-1 block text-sm" style={{
                  color: 'var(--muted)'
                }} data-id="element-112" data-mp="1qhbot56bcfc3">
                      {metric.label}
                    </span>
                  </dd>
                </div>)}
            </dl>
          </div>

          <div className="hidden w-full overflow-hidden rounded-2xl md:block" style={{
          aspectRatio: '1 / 1'
        }} data-id="element-113" data-mp="285nmw373lt4p">
            <NarraVideo data-id="element-114" data-mp="2d2ntcf7v0xwc" />
          </div>
        </div>
      </div>
    </section>;
}